/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Snapshot status.
*/
export enum SnapshotStatus {
  Pending = 'PENDING',
  WaitingForBackup = 'WAITING_FOR_BACKUP',
  BackupSnapshotInProgress = 'BACKUP_SNAPSHOT_IN_PROGRESS',
  InvalidForBackup = 'INVALID_FOR_BACKUP',
  Provisioned = 'PROVISIONED',
  Completed = 'COMPLETED',
  PartialCompleted = 'PARTIAL_COMPLETED',
  Failed = 'FAILED',
  PendingDeletion = 'PENDING_DELETION',
  FailedPendingDeletion = 'FAILED_PENDING_DELETION',
  SnapshotStatusUnspecified = 'SNAPSHOT_STATUS_UNSPECIFIED'
}
